<template>
  <v-app class="grey lighten-3">
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-container grid-list-md>
          <v-card>
            <v-card-title class="project">
              <div class="white--text headline">
                <span
                  >Project Status: <span class="black--text">Pending</span>
                </span>
              </div>
            </v-card-title>
            <v-card-text>
              <template>
                <v-data-table
                  :items="[indexData.project]"
                  class="elevation-1"
                  hide-actions
                  hide-headers
                >
                  <template v-slot:items="props">
                    <tr>
                      <td>Project ID</td>
                      <td class="text-xs-left">{{ props.item.id }}</td>
                    </tr>
                    <tr>
                      <td>Project Title</td>
                      <td class="text-xs-left">{{ props.item.name }}</td>
                    </tr>
                    <tr>
                      <td>Project Description</td>
                      <td class="text-xs-left">{{ props.item.details }}</td>
                    </tr>
                    <tr>
                      <td>Project Language</td>
                      <td class="text-xs-left">
                        {{ getProjectLanguage(props.item.project_language) }}
                      </td>
                    </tr>
                    <tr>
                      <td>Project Starting Time</td>
                      <td class="text-xs-left">{{ props.item.begin_date }}</td>
                    </tr>
                    <tr>
                      <td>Project Ending Time</td>
                      <td class="text-xs-left">{{ props.item.end_date }}</td>
                    </tr>
                    <tr>
                      <td>Total Budget</td>
                      <td class="text-xs-left">
                        {{ props.item.total_budget_amount }}
                      </td>
                    </tr>
                    <tr v-if="props.item.project_status_id >= 8">
                      <td>Total Budget(coins)</td>
                      <td class="text-xs-left">
                        {{ props.item.total_budget_coins }}
                      </td>
                    </tr>
                    <tr>
                      <td>Per Survey Cost</td>
                      <td class="text-xs-left">
                        {{ props.item.per_survey_cost }}
                      </td>
                    </tr>
                    <tr>
                      <td>Total Response</td>
                      <td class="text-xs-left">
                        {{ props.item.number_of_response }}
                      </td>
                    </tr>
                    <tr v-if="props.item.project_status_id >= 8">
                      <td>Remainig Balance</td>
                      <td class="text-xs-left">
                        {{ props.item.budget_remains }}
                      </td>
                    </tr>
                    <tr v-if="props.item.project_status_id >= 8">
                      <td>Holding Balance</td>
                      <td class="text-xs-left">
                        {{ props.item.holding_budget }}
                      </td>
                    </tr>
                    <tr v-if="props.item.project_status_id >= 8">
                      <td>Project Completed</td>
                      <td
                        class="text-xs-left"
                        v-if="props.item.completion_percentage == null"
                      >
                        0%
                      </td>
                      <td class="text-xs-left" v-else>
                        {{ props.item.completion_percentage }}%
                      </td>
                    </tr>
                    <tr v-if="props.item.agent_option == 3 && props.item.link">
                      <td>Web Survey link</td>
                      <td class="text-xs-left">
                        {{ indexData.web_url }}{{ props.item.link }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </template>
              <!-- <v-divider></v-divider> -->
            </v-card-text>
            <v-card v-if="checkData">
              <v-card-title class="project">
                <div>
                  <span class="headline white--text"> Pre Survey Question</span>
                </div>
              </v-card-title>
              <v-card-text>
                <div>
                  <div
                    v-for="(pre_ques, index) in indexData.pre_survey_question"
                    v-bind:key="index"
                  >
                    <!-- start pre survey question part -->
                    <div>
                      <span>Pre_Q{{ index + 1 }}.</span>
                      <span
                        v-if="
                          indexData.project.project_language == 1 ||
                          indexData.project.project_language == 3
                        "
                      >
                        <span class="font-weight-bold"
                          >Question Title English:</span
                        >
                        &nbsp;&nbsp;&nbsp;{{ pre_ques.question_title_en }}
                        <span
                          class="red--text headline"
                          v-if="pre_ques.required_optional == 1"
                        >
                          *
                        </span>
                      </span>
                      <br />
                      <span
                        v-if="
                          indexData.project.project_language == 2 ||
                          indexData.project.project_language == 3
                        "
                      >
                        &nbsp;&nbsp;&nbsp;
                        <span class="font-weight-bold"
                          >Question Title Bangla:</span
                        >
                        &nbsp;&nbsp;&nbsp;{{ pre_ques.question_title_bn }}
                        <br />
                        <span
                          class="red--text headline"
                          v-if="pre_ques.required_optional == 1"
                        >
                          *
                        </span>
                      </span>
                      <br />
                      <!-- option and multiple image section -->
                      <div
                        v-if="
                          pre_ques.ui_category_id == 1 ||
                          pre_ques.ui_category_id == 2 ||
                          pre_ques.ui_category_id == 4 ||
                          pre_ques.ui_category_id == 14
                        "
                      >
                        <div v-if="pre_ques.ui_category_id == 14">
                          <span
                            v-for="(option, i) in pre_ques.pre_image_options"
                            :key="i"
                          >
                            <v-img
                              height="150"
                              width="200"
                              :src="
                                indexData.pre_ques_option_base_url + option.url
                              "
                            ></v-img>
                            <a
                              :href="
                                indexData.pre_ques_option_base_url + option.url
                              "
                              target="_blank"
                              >download</a
                            >
                            <div class="mt-3"></div>
                          </span>
                        </div>
                        <div v-else>
                          <div
                            v-if="
                              pre_ques.pre_options &&
                              (indexData.project.project_language == 1 ||
                                indexData.project.project_language == 3)
                            "
                          >
                            <span class="font-weight-bold"
                              >Option English:</span
                            >
                            <br />
                            <span
                              v-for="(option, i) in pre_ques.pre_options"
                              :key="i"
                            >
                              <v-icon small> radio_button_unchecked </v-icon>
                              {{ option.title }}<br />
                            </span>
                          </div>
                          <div
                            v-if="
                              pre_ques.option_bangla != null &&
                              (indexData.project.project_language == 2 ||
                                indexData.project.project_language == 3)
                            "
                          >
                            <br />
                            <span class="font-weight-bold">Option Bangla:</span>
                            <br />
                            <span
                              v-for="(option, i) in pre_ques.pre_bangla_options"
                              :key="i"
                            >
                              <v-icon small> radio_button_unchecked </v-icon>
                              {{ option.title }}<br />
                            </span>
                          </div>
                        </div>
                      </div>

                      <div>
                        <span
                          v-if="
                            pre_ques.instruction != null &&
                            (indexData.project.project_language == 1 ||
                              indexData.project.project_language == 3)
                          "
                        >
                          <span class="font-weight-bold"
                            >Instruction English:</span
                          >
                          <div
                            v-html="
                              decode_info(pre_ques.pre_instruction.instruction)
                            "
                          ></div>
                        </span>
                        <span
                          v-if="
                            pre_ques.instruction_bangla != null &&
                            (indexData.project.project_language == 2 ||
                              indexData.project.project_language == 3)
                          "
                        >
                          <span class="font-weight-bold"
                            >Instruction Bangla:</span
                          >
                          &nbsp;&nbsp;&nbsp;
                          <div
                            v-html="
                              decode_info(
                                pre_ques.pre_instruction_bangla
                                  .instruction_bangla
                              )
                            "
                          ></div>
                        </span>
                        <span
                          v-if="
                            pre_ques.description != null &&
                            (indexData.project.project_language == 1 ||
                              indexData.project.project_language == 3)
                          "
                        >
                          <span class="font-weight-bold">
                            Description English:
                          </span>
                          &nbsp;&nbsp;&nbsp;
                          <div
                            v-html="
                              decode_info(pre_ques.pre_description.description)
                            "
                          ></div>
                        </span>
                        <span
                          v-if="
                            pre_ques.description_bangla != null &&
                            (indexData.project.project_language == 1 ||
                              indexData.project.project_language == 3)
                          "
                        >
                          <span class="font-weight-bold">
                            Description Bangla:</span
                          >
                          &nbsp;&nbsp;&nbsp;
                          <div
                            v-html="
                              decode_info(
                                pre_ques.pre_description_bangla
                                  .description_bangla
                              )
                            "
                          ></div>
                        </span>
                      </div>
                      <div>
                        <pre-survey-question-logic
                          :pre_question_logic="pre_ques.pre_question_logic"
                          :operators="indexData.operators"
                        />
                      </div>
                    </div>
                    <!-- end pre survey question part -->
                  </div>
                </div>
              </v-card-text>
            </v-card>

            <v-card>
              <v-card-title class="project">
                <div><span class="headline white--text">Question</span></div>
              </v-card-title>
              <v-card-text>
                <div>
                  <span class="font-weight-bold"
                    >Note:Here star mark (<span class="red--text">*</span>) is
                    required.</span
                  >
                  <br />
                  <div
                    v-for="(ques, index) in indexData.question"
                    v-bind:key="index"
                  >
                    <!-- question part -->
                    <div>
                      <span>{{ index + 1 }}.</span>
                      <span
                        v-if="
                          indexData.project.project_language == 1 ||
                          indexData.project.project_language == 3
                        "
                      >
                        <span class="font-weight-bold"
                          >Question Title English:</span
                        >
                        &nbsp;&nbsp;&nbsp;{{ ques.question }}
                        <span
                          class="red--text headline"
                          v-if="ques.required_optional == 1"
                        >
                          *
                        </span>
                      </span>
                      <br />
                      <span
                        v-if="
                          indexData.project.project_language == 2 ||
                          indexData.project.project_language == 3
                        "
                      >
                        &nbsp;&nbsp;&nbsp;
                        <span class="font-weight-bold"
                          >Question Title Bangla:</span
                        >
                        &nbsp;&nbsp;&nbsp;{{ ques.question_bangla }} <br />
                        <span
                          class="red--text headline"
                          v-if="ques.required_optional == 1"
                        >
                          *
                        </span>
                      </span>
                      <br />
                      <span>
                        <span class="font-weight-bold">Question Type:</span>
                        &nbsp;&nbsp;&nbsp;{{ ques.ui_category.name }}
                        <br />
                      </span>
                      <br />
                      <div v-if="ques.ui_category_id == 15">
                        <span v-if="ques.contact_info.first_name == '1'">
                          First Name: _________
                        </span>
                        <span v-if="ques.contact_info.middle_name == '1'">
                          <br />
                          Middle Name: _________
                        </span>
                        <span v-if="ques.contact_info.last_name == '1'">
                          <br />
                          Last Name: _________
                        </span>
                        <span v-if="ques.contact_info.phone == '1'">
                          <br />
                          <v-icon small> call </v-icon>Phone: _________
                        </span>
                        <span v-if="ques.contact_info.email == '1'">
                          <br />email: _________
                        </span>
                        <span v-if="ques.contact_info.address == '1'">
                          <br /><v-icon small> home </v-icon
                          ><span class="font-weight-bold"> Address:</span>
                          <br />Country: _________ <br />Division: _________
                          <br />District : _________ <br />Area: _________
                          <br />Road No: _________ <br />House No: _________
                        </span>
                      </div>
                      <!-- option and multiple image section -->
                      <div
                        v-if="
                          ques.ui_category_id == 1 ||
                          ques.ui_category_id == 2 ||
                          ques.ui_category_id == 4 ||
                          ques.ui_category_id == 14
                        "
                      >
                        <div
                          v-if="ques.ui_category_id == 14 && ques.image_options"
                        >
                          <span
                            v-for="(option, i) in ques.image_options"
                            :key="i"
                          >
                            <v-img
                              height="150"
                              width="200"
                              :src="indexData.image_op + option.url"
                            ></v-img>
                            <a
                              :href="indexData.image_op + option.url"
                              target="_blank"
                            >
                              download</a
                            >
                            <div class="mt-3"></div>
                          </span>
                        </div>
                        <div v-else>
                          <div
                            v-if="
                              ques.options &&
                              (indexData.project.project_language == 1 ||
                                indexData.project.project_language == 3)
                            "
                          >
                            <span class="font-weight-bold"
                              >Option English:</span
                            >
                            <br />
                            <span v-for="(option, i) in ques.options" :key="i">
                              <v-icon small> radio_button_unchecked </v-icon>
                              {{ option.title }}<br />
                            </span>
                          </div>
                          <div
                            v-if="
                              ques.bangla_options != null &&
                              (indexData.project.project_language == 2 ||
                                indexData.project.project_language == 3)
                            "
                          >
                            <br />
                            <span class="font-weight-bold">Option Bangla:</span>
                            <br />
                            <span
                              v-for="(option, i) in ques.bangla_options"
                              :key="i"
                            >
                              <v-icon small> radio_button_unchecked </v-icon>
                              {{ option.title }}<br />
                            </span>
                          </div>
                        </div>
                      </div>

                      <div>
                        <span
                          v-if="
                            ques.instruction != null &&
                            (indexData.project.project_language == 1 ||
                              indexData.project.project_language == 3)
                          "
                        >
                          <span class="font-weight-bold"
                            >Instruction English:</span
                          >
                          <div
                            v-html="decode_info(ques.instruction.instruction)"
                          ></div>
                        </span>
                        <span
                          v-if="
                            ques.instruction_bangla != null &&
                            (indexData.project.project_language == 2 ||
                              indexData.project.project_language == 3)
                          "
                        >
                          <span class="font-weight-bold"
                            >Instruction Bangla:</span
                          >
                          &nbsp;&nbsp;&nbsp;
                          <div
                            v-html="
                              decode_info(
                                ques.instruction_bangla.instruction_bangla
                              )
                            "
                          ></div>
                        </span>
                        <span
                          v-if="
                            ques.description != null &&
                            (indexData.project.project_language == 1 ||
                              indexData.project.project_language == 3)
                          "
                        >
                          <span class="font-weight-bold">
                            Description English:
                          </span>
                          &nbsp;&nbsp;&nbsp;
                          <div
                            v-html="decode_info(ques.description.description)"
                          ></div>
                        </span>
                        <span
                          v-if="
                            ques.description_bangla != null &&
                            (indexData.project.project_language == 1 ||
                              indexData.project.project_language == 3)
                          "
                        >
                          <span class="font-weight-bold">
                            Description Bangla:</span
                          >
                          &nbsp;&nbsp;&nbsp;
                          <div
                            v-html="
                              decode_info(
                                ques.description_bangla.description_bangla
                              )
                            "
                          ></div>
                        </span>
                      </div>
                      <!-- date time question -->
                      <div v-if="ques.ui_category_id == 12">
                        <span v-if="ques.date_time.date_time != null">
                          <span class="font-weight-bold">Date: </span
                          >{{ ques.date_time.date_time }}
                        </span>
                      </div>
                      <!-- multiple answer -->
                      <div v-if="ques.ui_category_id == 2">
                        <span class="font-weight-bold">Multiple ans:</span>
                        <v-icon small class="mr-1"
                          >check_box_outline_blank</v-icon
                        >
                        <span v-if="ques.multiple_answer == 1">yes</span>
                        <span v-else>no</span>
                      </div>
                      <!-- range slider star rating -->
                      <div
                        v-if="
                          ques.ui_category_id == 6 ||
                          ques.ui_category_id == 7 ||
                          ques.ui_category_id == 8
                        "
                      >
                        <span
                          v-if="
                            ques.option_val.min_value != null &&
                            ques.option_val.max_value != null
                          "
                        >
                          <span class="font-weight-bold">Min value: </span
                          >{{ ques.option_val.min_value }}<br />
                          <span class="font-weight-bold">Max value: </span
                          >{{ ques.option_val.max_value }}
                        </span>
                        <span v-if="ques.option_val.interval != null">
                          <br /><span class="font-weight-bold">Interval: </span
                          >{{ ques.option_val.interval }}
                        </span>
                      </div>
                      <div v-if="ques.has_logic">
                        <question-logic
                          :question_logic="
                            JSON.parse(ques.question_logic.question_logic)
                          "
                          :questions="indexData.question"
                          :counter_index="index"
                        />
                      </div>
                    </div>
                    <!-- end question part -->
                  </div>
                </div>
              </v-card-text>
            </v-card>
            <!-- <v-btn @click="save">submit</v-btn> -->
            <assigned-agent-group-to-project
              v-if="has_agent_group()"
              :project_id="indexData.project.id"
            ></assigned-agent-group-to-project>
            <assigned-teams-to-project
              v-if="has_team()"
              :project_id="indexData.project.id"
            ></assigned-teams-to-project>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import {
  QuestionLogic,
  PreSurveyQuestionLogic,
  AssignedAgentGroupToProject,
  AssignedTeamsToProject,
} from "@/components/index";
// import router from '@/router'

export default {
  components: {
    QuestionLogic,
    PreSurveyQuestionLogic,
    AssignedAgentGroupToProject,
    AssignedTeamsToProject,
  },
  data: () => ({
    apiUrl: "client-view",
    editedIndex: -1,
    dialog: false,
    projectId: null,
    status_name: null,
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    checkData() {
      if (this.indexData.project) {
        if (this.indexData.project.has_pre_survey) {
          return 1;
        } else {
          return 0;
        }
      }
      return 0;
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      //get submitted project id
      this.projectId = localStorage.getItem("submitted_project_id");
      if (this.projectId != null) {
        this.$store.dispatch("getSubmittedProject", [
          this.projectId,
          this.apiUrl,
        ]);
      } else {
        alert("Project id should not be null!");
      }
    },
    decode_info(value) {
      if (value != undefined) {
        return JSON.parse(value);
      }
      return "";
    },
    has_agent_group() {
      if (this.indexData.project) {
        if (this.indexData.project.dasher_category_id === 3) {
          // console.log(this.indexData);
          return 1;
        }
      } else {
        return 0;
      }
    },
    has_team() {
      if (this.indexData.project) {
        if (this.indexData.project.dasher_category_id === 2) {
          // console.log(this.indexData);
          return 1;
        }
      } else {
        return 0;
      }
    },
    getProjectLanguage(project_language) {
      if (project_language == 1) {
        return "English";
      } else if (project_language == 2) {
        return "Bangla";
      } else {
        return "English & Bangla both";
      }
    },

    close() {
      setTimeout(() => {
        this.budget = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      // console.log(localStorage.getItem('submitted_project_id'));
      // if (this.editedIndex > -1) {
      //   this.$store.dispatch('store', [this.apiUrl, this.budget])
      // } else {
      //   this.$store.dispatch('store', [this.apiUrl, this.budget])
      // }
      // this.close()
    },
  },
};
</script>

<style scoped>
.icon {
  background: #ff2e2e;
  color: aliceblue;
  cursor: pointer;
  border-radius: none;
  margin: 10px;
}
.delete {
  color: #3f51b5;
  cursor: pointer;
}
span {
  width: 20px;
  cursor: pointer;
}
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: white;
}
.text_color {
  color: white;
}
.project {
  background: #ff2e2e;
}
</style>
